var swiper = new Swiper(".ab-key-points-swiper", {
  slidesPerView: 1,
  spaceBetween: 32,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 16,
    },
    1025: {
      slidesPerView: 4,
      allowTouchMove: false, // disable drag/swipe on desktop
    },
  }
});

var swiper = new Swiper(".ab-swiper-for-reviews", {
  slidesPerView: 3,
  spaceBetween: 26,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    // when window width is >= 1000px
    1000: {
      slidesPerView: 3,
      spaceBetween: 16,
    },
    // when window width is >= 768px
    660: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    // when window width is < 768px
    0: {
      slidesPerView: 1,
      spaceBetween: 16,
    },
  }
});


function setEqualHeight(selector) {
  const cards = document.querySelectorAll(selector);

  if (cards.length === 0) return;

  // Reset heights
  cards.forEach(card => {
    card.style.height = 'auto';
  });

  // Find max height
  let maxHeight = 0;
  cards.forEach(card => {
    maxHeight = Math.max(maxHeight, card.offsetHeight);
  });

  // Set all to max height
  cards.forEach(card => {
    card.style.height = maxHeight + 'px';
  });
}

// Combined runner function
function runEqualHeights() {
  setEqualHeight('.ab-key-points');
  setEqualHeight('.ab-review-card'); // <- Add your actual card class here
  setEqualHeight('.ab-blog-text');
}

// Run on DOM load and resize
window.addEventListener('load', runEqualHeights);
window.addEventListener('resize', runEqualHeights);


 document.addEventListener("DOMContentLoaded", () => {
    const video = document.getElementById("myVideo");
    const button = document.getElementById("playPauseBtn");
    const playIcon = document.querySelector(".play-icon");
    const pauseIcon = document.querySelector(".pause-icon");
    const loader = document.getElementById("videoLoader");
    const wrapper = document.querySelector(".ab-video-clip");

    // Show loader while buffering
    video.addEventListener("waiting", () => loader.style.display = "block");
    video.addEventListener("canplay", () => loader.style.display = "none");
    video.addEventListener("playing", () => loader.style.display = "none");

    // Toggle play/pause on button click
    button.addEventListener("click", (e) => {
      e.stopPropagation();
      video.paused ? video.play() : video.pause();
    });

    // When paused, show play icon
    video.addEventListener("pause", () => {
      playIcon.style.display = "block";
      pauseIcon.style.display = "none";
      button.style.opacity = 1;
      button.style.pointerEvents = "auto";
    });

    // When playing, briefly show pause icon then fade
    video.addEventListener("play", () => {
      playIcon.style.display = "none";
      pauseIcon.style.display = "flex";
      button.style.opacity = 1;
      button.style.pointerEvents = "auto";

      setTimeout(() => {
        if (!wrapper.matches(":hover")) {
          button.style.opacity = 0;
          button.style.pointerEvents = "none";
        }
      }, 600);
    });

    // Show button on hover
    wrapper.addEventListener("mouseenter", () => {
      button.style.opacity = 1;
      button.style.pointerEvents = "auto";
    });

    wrapper.addEventListener("mouseleave", () => {
      if (!video.paused) {
        button.style.opacity = 0;
        button.style.pointerEvents = "none";
      }
    });
  });

document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector('#ab-after-before-section');
  if (!section) return;

  const swiper = new Swiper(section.querySelector('.ab-after-before'), {
    allowTouchMove: false,
    autoplay: false,
    navigation: false,
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: section.querySelector('.swiper-pagination'),
      clickable: true,
    },
  });

  section.querySelectorAll('.before-after-wrapper').forEach(wrapper => {
    const beforeImg = wrapper.querySelector('.before-image');
    const handle = wrapper.querySelector('.handle');

    let isDragging = false;

    const updatePosition = (clientX) => {
      const rect = wrapper.getBoundingClientRect();
      const x = clientX - rect.left;
      const percent = Math.max(0, Math.min(100, (x / rect.width) * 100));
      beforeImg.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
      handle.style.left = `${percent}%`;
    };

    const onPointerMove = (e) => {
      if (!isDragging) return;
      requestAnimationFrame(() => {
        updatePosition(e.clientX);
      });
    };

    const stopDragging = () => {
      isDragging = false;
      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', stopDragging);
    };

    wrapper.addEventListener('pointerdown', (e) => {
      // Only start drag if user clicked the handle (optional toggle)
      // if (!e.target.classList.contains('handle')) return;

      isDragging = true;
      updatePosition(e.clientX);
      window.addEventListener('pointermove', onPointerMove);
      window.addEventListener('pointerup', stopDragging);
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('#ab-blog-slider-section');
  const swiperContainer = section?.querySelector('.ab-blogs');
  const paginationEl = section?.querySelector('.swiper-pagination');

  if (!swiperContainer) return;

  let swiperInstance = null;

  function initSwiper() {
    const windowWidth = window.innerWidth;

    // Reset previous state
    swiperContainer.classList.remove('swiper-disabled');
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
    if (paginationEl) {
      paginationEl.style.display = 'none';
    }

    // Initialize only if 1024px or below
    if (windowWidth <= 1024) {
      swiperInstance = new Swiper(swiperContainer, {
        slidesPerView: windowWidth <= 768 ? 1 : 2,
        spaceBetween: 20,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
      });

      if (paginationEl) {
        paginationEl.style.display = 'block';
      }
    } else {
      swiperContainer.classList.add('swiper-disabled');
    }
  }

  initSwiper();
  window.addEventListener('resize', initSwiper);
});



$(document).ready(function () {
  $('.ab-QA p').hide(); // Hide all answers initially

  $('.ab-Q-arrow').on('click', function () {
    const $qa = $(this).closest('.ab-QA');
    const $para = $qa.find('p');

    $('.ab-QA').not($qa).removeClass('open').find('p').slideUp();
    $qa.toggleClass('open');
    $para.slideToggle();
  });
});



$(document).ready(function () {
  $('.ab-table-data-2').each(function () {
    let sum = 0;

    $(this).find('p').each(function (index, el) {
      const text = $(this).text().trim().toLowerCase();

      // Handle Yes/No coloring
      if (text === 'yes') {
        $(this).css('color', '#56BF26');
      } else if (text === 'no') {
        $(this).css('color', '#BF3F26');
      }

      // Handle Dollar amounts
      if (text.includes('$')) {
        // Extract the numeric part, remove commas and dollar signs
        const value = parseFloat(text.replace(/[^0-9.]/g, ''));
        if (!isNaN(value)) {
          sum += value;
        }
      }
    });

    // Write total to the last <p> in this .ab-table-data block
    const $lastP = $(this).find('p').last();
    $lastP.text('$' + sum);
  });
});
